function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));

      // Normaliza lo tipeado a mano (decimales, negativos, texto, fuera de rango).
      // Corre en fase target (antes de que el change burbujee al cart-drawer),
      // asi el carrito lee siempre un valor ya saneado.
      this.input.addEventListener('change', () => this.normalizeInput());
      this.input.addEventListener('blur', () => this.normalizeInput());

      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    getMin() {
      const min = parseInt(this.input.min, 10);
      return Number.isNaN(min) ? 1 : min;
    }
    getMax() {
      const max = parseInt(this.input.max, 10);
      return Number.isNaN(max) ? Infinity : max;
    }
    normalizeInput() {
      const min = this.getMin();
      const max = this.getMax();
      let value = Math.round(parseFloat(this.input.value));
      const shouldBlockInvalidSubmit = this.input.name === 'quantity' && this.closest('product-form');
      const isInvalid = Number.isNaN(value) || value < min || value > max || (value - min) % this.step !== 0;
      if (shouldBlockInvalidSubmit && isInvalid) {
        this.input.setAttribute('aria-invalid', 'true');
        this.validateQtyRules();
        return;
      }
      this.input.removeAttribute('aria-invalid');
      if (Number.isNaN(value)) value = min;
      value = Math.min(Math.max(value, min), max);
      if (String(value) !== this.input.value) {
        this.input.value = value;
      }
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;

      const min = this.getMin();
      const max = this.getMax();
      const newValue = Math.min(Math.max(quantity + change, min), max);
      if (newValue === quantity) return;

      this.input.value = newValue;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }

    validateQtyRules() {
      const min = this.getMin();
      const max = this.getMax();
      const value = parseInt(this.input.value) || min;

      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);

      // Mantiene el arbol de accesibilidad consistente (evita aria-valuemax=0
      // que reportaba el spinbutton nativo cuando faltaba el max real).
      this.input.setAttribute('aria-valuenow', value);
      this.input.setAttribute('aria-valuemin', min);
      if (max === Infinity) {
        this.input.removeAttribute('aria-valuemax');
      } else {
        this.input.setAttribute('aria-valuemax', max);
      }
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      // El srcset real lo trae el atributo srcset de la imagen (responsive-image
      // no usa data-srcset). Nunca puede quedar undefined.
      this.org_srcset = this.image ? (this.image.dataset.srcset || this.image.getAttribute('srcset') || '') : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        // El data-srcset vive en el <input> (previousElementSibling), no en el <label>.
        // Sin este guard, image.srcset = undefined disparaba un GET a /collections/undefined.
        const swatch_input = swatch.previousElementSibling;
        const swatch_srcset = swatch_input && swatch_input.dataset ? swatch_input.dataset.srcset : '';
        if (swatch_srcset) {
          window.addEventListener('load', () => {
            let image = new Image();
            image.srcset = swatch_srcset;
            lazySizes.loader.unveil(image);
          });
        }
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else if (this.org_srcset) {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableQuickAdd() {
      // connectedCallback corre en cada reinsercion del card en el DOM (la grilla
      // de recomendados los reinyecta). .bind() devuelve una funcion nueva cada
      // vez, asi que addEventListener no puede deduplicar y los listeners se
      // apilan: un solo click terminaba disparando N POST /cart/add.
      if (this.quick_add.dataset.quickAddBound === 'true') {
        return;
      }
      this.quick_add.dataset.quickAddBound = 'true';
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      // 'loading' ya marcaba el request en vuelo pero nadie lo leia: sirve de
      // cerrojo contra el doble disparo (mismo click, o click impaciente).
      if (this.quick_add.disabled || this.quick_add.classList.contains('loading')) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const sourceHtml = parsedState.sections?.[section.section];
        if (!sourceHtml) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const sourceInnerHTML = this.getSectionInnerHTML(sourceHtml, section.selector);
        if (sourceInnerHTML == null) {
          return;
        }
        elementToReplace.innerHTML = sourceInnerHTML;
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.onCartRefresh = () => this.refresh();
      this.onDrawerChange = this.debouncedOnChange.bind(this);
      this.onDocumentClick = this.onWindowClick.bind(this);
      this.onToggleClick = (event) => {
        event.preventDefault();
        this.isOpen ? this.close() : this.open();
      };
      this.onDocumentKeyup = (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE') this.close();
      };
      // Focus trap: mientras el drawer esta abierto, Tab/Shift+Tab ciclan solo
      // entre los focables internos y no escapan al contenido de fondo (aria-modal).
      this.onTrapKeydown = (event) => {
        if (event.key !== 'Tab' || !this.isOpen) return;
        const focusables = this.getFocusableElements();
        if (!focusables.length) {
          event.preventDefault();
          this.focus();
          return;
        }
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (event.shiftKey) {
          if (active === first || active === this || !this.contains(active)) {
            event.preventDefault();
            last.focus();
          }
        } else if (active === last || !this.contains(active)) {
          event.preventDefault();
          first.focus();
        }
      };

      document.addEventListener('cart:refresh', this.onCartRefresh);
      this.addEventListener('change', this.onDrawerChange);

      this.removeProductEvent();

      document.addEventListener('click', this.onDocumentClick);
      this.button?.addEventListener('click', this.onToggleClick);
      document.addEventListener('keyup', this.onDocumentKeyup);

      this.updateEmptyState();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:refresh', this.onCartRefresh);
      this.removeEventListener('change', this.onDrawerChange);
      document.removeEventListener('click', this.onDocumentClick);
      this.button?.removeEventListener('click', this.onToggleClick);
      document.removeEventListener('keyup', this.onDocumentKeyup);
      document.removeEventListener('keydown', this.onTrapKeydown);
      this._initialized = false;
    }

    getFocusableElements() {
      return Array.from(this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((el) => el.offsetParent !== null && !el.closest('[inert]'));
    }

    updateEmptyState() {
      const isEmpty = !this.querySelector('.product-cart-item');
      this.classList.toggle('cart-drawer--empty', isEmpty);
    }

    onWindowClick(event) {
      if (!this.contains(event.target) && this.isOpen && !this.button?.contains(event.target)) {
        this.close();
      }
    }
    open() {
      if (!this.isOpen) {
        // Guardamos el disparador para devolverle el foco al cerrar (Bug #5).
        // Un click de mouse no siempre mueve el foco, y open() tambien se llama
        // por codigo tras agregar al carrito: en esos casos activeElement es
        // <body>, que pasa los chequeos de close() pero no es focusable, y el
        // foco terminaba en <body> en vez del toggle. Solo se guarda un elemento
        // realmente focusable; si no, se usa el toggle del carrito.
        const activeOpener = document.activeElement;
        const validOpener = activeOpener
          && activeOpener !== document.body
          && activeOpener !== document.documentElement
          && !this.contains(activeOpener)
          && typeof activeOpener.focus === 'function';
        this.opener = validOpener ? activeOpener : this.button;
        // Bloqueo del scroll de fondo. Sin esto, deslizar sobre el header del
        // drawer, la barra de envio gratis o la botonera movia la pagina de atras
        // (medido: scrollY 0 -> 455). Solo .cart-drawer--content se salvaba, por su
        // overscroll-behavior: contain.
        //
        // Va en <html>, NO solo en <body>: el contenedor de scroll de esta pagina es
        // el documento, asi que `body { overflow: hidden }` no frena nada. Verificado
        // en el preview: con body en hidden el fondo se seguia yendo (448 -> 1048).
        // Es el mismo patron que usa openDrawer del menu mobile
        // (snippets/header-mobile-menu.liquid), que por esto mismo tampoco bloquea.
        // Se guarda el valor previo de ambos en vez de asumir '' para no pisar el
        // bloqueo de otro componente.
        //
        // El lock va SOLO en <html>. Poner `overflow:hidden` tambien en <body>
        // convierte al body en contenedor de scroll, y el header (position:
        // sticky) se pega respecto de su ancestro scrolleable: al cambiarselo,
        // pierde el anclaje y cae a su posicion estatica. Medido en el preview
        // con la pagina en scrollY 2500: el header saltaba de top 0 a top -2472,
        // o sea desaparecia de pantalla. Con el lock solo en <html> el header
        // queda en top 0 y el scroll igual no se mueve.
        this._prevOverflow = {
          html: document.documentElement.style.overflow
        };
        document.documentElement.style.overflow = 'hidden';
      }
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      this.button?.setAttribute('aria-expanded', 'true');
      this.updateEmptyState();
      document.addEventListener('keydown', this.onTrapKeydown);
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      const wasOpen = this.isOpen;
      this.setAttribute('inert', '');
      this.isOpen = false;
      this.button?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onTrapKeydown);
      if (!wasOpen) return;
      const prev = this._prevOverflow || { html: '' };
      document.documentElement.style.overflow = prev.html || '';
      this._prevOverflow = null;
      const opener = this.opener;
      this.opener = null;
      const target = (opener && opener.isConnected && typeof opener.focus === 'function') ? opener : this.button;
      target?.focus();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          this.updateQuantity(event.currentTarget.dataset.index, '0');
        });
      });
    }
    showError(message) {
      let error = this.querySelector('[data-cart-drawer-error]');
      if (!error) {
        error = document.createElement('p');
        error.dataset.cartDrawerError = '';
        error.className = 'cart-drawer__error';
        error.setAttribute('role', 'alert');
        this.querySelector('.cart-drawer--content')?.prepend(error);
      }
      error.textContent = message || 'No pudimos actualizar el carrito. Intentá nuevamente.';
      error.hidden = false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then(async (response) => {
          const state = await response.text();
          const parsedState = JSON.parse(state);
          if (!response.ok || parsedState.status || parsedState.errors) {
            throw new Error(parsedState.description || parsedState.message || 'No pudimos actualizar el carrito.');
          }
          return parsedState;
        })
        .then((parsedState) => {
          this.getSectionsToRender().forEach((section => {
            const sectionRoot = document.getElementById(section.id);
            const elementToReplace = sectionRoot?.querySelector(section.selector) || sectionRoot;
            if (!elementToReplace) return;

            const sourceHtml = parsedState.sections?.[section.section];
            if (sourceHtml) {
              const sourceInnerHTML = this.getSectionInnerHTML(sourceHtml, section.selector);
              if (sourceInnerHTML != null) {
                elementToReplace.innerHTML = sourceInnerHTML;
              }
            }
          }));

          this.removeProductEvent();
          this.updateEmptyState();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

        })
        .catch((error) => {
          return this.refresh().finally(() => this.showError(error.message));
        })
        .finally(() => {
          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      return fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          if (!response.ok) throw new Error(`Cart refresh failed: ${response.status}`);
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const sectionRoot = document.getElementById(section.id);
            const elementToReplace = sectionRoot?.querySelector(section.selector) || sectionRoot;
            if (!elementToReplace) return;
            const sourceHtml = parsedState[section.section];
            if (!sourceHtml) {
              return;
            }

            const sourceInnerHTML = this.getSectionInnerHTML(sourceHtml, section.selector);
            if (sourceInnerHTML == null) {
              return;
            }
            elementToReplace.innerHTML = sourceInnerHTML;
          }));

          this.removeProductEvent();
          this.updateEmptyState();
        })
        .catch((error) => this.showError(error.message));
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;
      this.onActivate = this.setupEventListener.bind(this);

      this.addEventListener('click', this.onActivate);
      this.addEventListener('keydown', this.onActivate);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onActivate);
      this.removeEventListener('keydown', this.onActivate);
      this._initialized = false;
    }
    setupEventListener(e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        const js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script[src]');

        if (js_files.length > 0) {
          const head = document.head;
          js_files.forEach((js_file) => {
            if (Array.from(document.scripts).some((loadedScript) => loadedScript.src === js_file.src)) return;
            const script = document.createElement('script');
            script.src = js_file.src;
            script.defer = js_file.defer;
            if (js_file.type) script.type = js_file.type;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.drawer.setAttribute('open', '');
        this.drawer.querySelector('.product-modal__toggle').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});

      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {

      e.preventDefault();
      this.details.style.overflow = 'hidden';

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      this.isClosing = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

// Trackear el producto en CADA visita a la ficha. Antes solo se registraba al
// abrir un quick-view, asi que "Vistos recientemente" casi nunca se llenaba.
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.thb-product-detail')) {
    addIdToRecentlyViewed();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});
